function safeReplace(a, search, replaceValue) {
  if (a === undefined) {
    return 'undefined';
  }
  return a.replace(search, replaceValue);
}
export function joinURL() {
  let url = arguments.length <= 0 ? undefined : arguments[0];
  for (let i = 1; i < arguments.length; ++i) {
    url = safeReplace(url, /\/$/, '') + '/' + safeReplace(i < 0 || arguments.length <= i ? undefined : arguments[i], /^\//, '');
  }
  return url;
}
//# sourceMappingURL=helpers.js.map